module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Sort#3-82fa2a2ab82e756d3e5868ade6cd9b07.svg";